import { EventType } from "../_game/config/Events"; 

class EventDispatcher {
	/** This is the events object */
	events: any;

	/**
	 * @desc This is the main EventDispatcher of the game
	 */
	constructor() {
		this.events = {};

		Object.keys(EventType).forEach((eventClass) => {
			this.events[eventClass] = {
				listeners: [],
			};
		});
	}

	/** Add new listener to the event list - the callback will receive (class, type, payload) */
	public addListener(eventClass: string, _callback: any, _scope: any) {
		// Check if this event not exists
		if (this.events[eventClass] === undefined) {
			this.events[eventClass] = {
				listeners: [],
			};
		}

		this.events[eventClass].listeners.push({ callback: _callback, scope: _scope });
	}

	/** Remove existing listener from the event list */
	public removeListener(eventClass: string, _callback: any, _scope: any) {
		// Check if this event not exists
		if (this.events[eventClass] === undefined) {
			//TODO - ERROR
		}

		this.events[eventClass].listeners = this.events[eventClass].listeners.filter(
			(listener: any) =>
				listener.callback.toString() !== _callback.toString() || listener.scope.toString() !== _scope.toString()
		);
	}

	/** Remove existing listener from the event list */
	public removeListenerByID(eventClass: string, _callback: any, _id: string) {
		// Check if this event not exists
		if (this.events[eventClass] === undefined) {
			//TODO - ERROR
		}

		this.events[eventClass].listeners = this.events[eventClass].listeners.filter(
			(listener: any) => listener.listenerID !== _id
		);
	}

	/** Dispatches an event with a payload */
	public dispatch(eventClass: string, eventType: string, eventPayload?: any) {
		// Check if this event not exists
		if (this.events[eventClass] === undefined) {
			//TODO - ERROR
		}

		// @ts-ignore
		if (!EventType[eventClass][eventType]) {
			//TODO - ERROR
		}

		this.events[eventClass].listeners.forEach((listener: any) => {
			//.call calls the "callback" callback as if it belongs to listener.scope
			listener.callback.call(listener.scope, eventClass, eventType, eventPayload);
		});
	}
}

export default EventDispatcher;
